import { render, staticRenderFns } from "./PatreonLink.vue?vue&type=template&id=3bfd7fb1&"
import script from "./PatreonLink.vue?vue&type=script&lang=js&"
export * from "./PatreonLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports